function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore';
import { BaseFeaturesComponent } from '../_base/base-features.component';
var PanelBusquedaHistoricComponentCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  PanelBusquedaHistoricComponentCtrl.$inject = ["$log", "$timeout", "AccesoDatos", "appConfigService"];
  function PanelBusquedaHistoricComponentCtrl($log, $timeout, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, PanelBusquedaHistoricComponentCtrl);
    _this = _callSuper(this, PanelBusquedaHistoricComponentCtrl, [appConfigService]);
    _defineProperty(_this, "filtroHist", {
      value: null
    });
    _defineProperty(_this, "listado", {
      valido: false,
      list: []
    });
    _defineProperty(_this, "panelcv", {
      $visible: false,
      cv: null
    });
    _this.$log = $log;
    _this.$timeout = $timeout;
    _this.AccesoDatos = AccesoDatos;
    return _this;
  }
  _inherits(PanelBusquedaHistoricComponentCtrl, _BaseFeaturesComponen);
  return _createClass(PanelBusquedaHistoricComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[PanelBusquedaHistoricComponentCtrl] onInit');
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (tiposResponse) {
        return _this2.datosTipos = new TiposDocEstadosStore(tiposResponse);
      });
    }
  }, {
    key: "aplicaFiltrosHist",
    value: function aplicaFiltrosHist() {
      var _this3 = this;
      var _f = {
        estado: null,
        limit: -1,
        idcvhist: null,
        q_value: this.filtroHist.value,
        usuarioGestor: null
      };
      this._callbackHistorico(_f) //
      .then(function (listadoRes) {
        _this3.listado.list = listadoRes.cvList;
        _this3.listado.valido = true;
      });
    }
  }, {
    key: "_callbackHistorico",
    value: function _callbackHistorico(_f) {
      if (this.esAdmin()) {
        return this.AccesoDatos.HistoricCurr_CLIENT.listCV(_f);
      } else return this.AccesoDatos.HistoricSolicitudes_CLIENT.listCV(_f);
    }
  }, {
    key: "accesscvhist",
    value: function accesscvhist(idx) {
      this.$log.debug('access', this.listado.list[idx]);
      this.panelcv.cv = this.listado.list[idx];
      this.panelcv.$visible = true;
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('panelBusquedaHistoric', {
  bindings: {},
  controller: PanelBusquedaHistoricComponentCtrl,
  // templateUrl: "panel-busqueda-historic.component.html",
  template: require('./panel-busqueda-historic.component.html')
});